module.exports = __webpack_public_path__ + "static/media/em-225.7932aaa8.png";